import { PaymentOption } from '../../../../types/CoreShoppingExperience';
import type Currency from '../../../../types/payment/Currency';

export const pointsCurrency: Currency = {
  symbol: '',
  label: 'common.currency.PTS',
  code: 'PTS',
};

const getProperCurrencyByPaymentOption = (currency: Currency, paymentOption: PaymentOption) =>
  paymentOption === PaymentOption.CASH ? currency : pointsCurrency;

export default getProperCurrencyByPaymentOption;
